import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { SnackBar } from '../../../components/shared/Snackbar'
import { useRetrieveDocumentListQueryForSelectedAccounts } from '../../../store/rdot360Context/useRdot360DocumentsContext'
import LoaderContainer from '../DocumentFilter/LoaderContainer'
import {
  getSelectedDateRange,
  getSearchDateEnd,
  getSearchDateBegin,
  getIsDownloading,
  useDocumentModuleStore,
  getShowAllAccounts
} from '../DocumentFilter/store'
import TaxDocumentsTable from './TaxDocumentsTable'

const TaxDocumentsTab = () => {
  const tab = 'Tax Documents'
  const selectedDateRange = useSelector(getSelectedDateRange)
  const selectedSearchDateEnd = useSelector(getSearchDateEnd(tab))
  const selectedSearchDateBegin = useSelector(getSearchDateBegin(tab))
  const showAllAccounts = useSelector(getShowAllAccounts())
  const isDownloading = useSelector(getIsDownloading)
  const { data, isLoading, isFetching, isUninitialized } =
    useRetrieveDocumentListQueryForSelectedAccounts(
      !!(selectedSearchDateBegin && selectedSearchDateEnd) && {
        VirtualTable: 'NF_TAX_DOCUMENTS',
        SearchDateComparison: 'R',
        SearchDateBegin: selectedSearchDateBegin,
        SearchDateEnd: selectedSearchDateEnd,
        SearchDateEndSpecified: true,
        SearchAllVersions: true,
        IncludeRelationships: false,
        RenditionFilter: '*',
        DateRange: selectedDateRange
      },
      showAllAccounts
    )

  const { clearSelection } = useDocumentModuleStore()
  useEffect(() => {
    clearSelection()
  }, [data, clearSelection])

  return (
    <>
      <LoaderContainer
        isLoading={isLoading}
        isFetching={isFetching}
        isDownloading={isDownloading}
        dataListCount={data?.DocumentList?.length || 0}
      />
      <TaxDocumentsTable items={data?.DocumentList} />
      {!isUninitialized && !isFetching && data?.DocumentList?.length === 0 ? (
        <SnackBar type="Info" message="No Data Available" />
      ) : (
        ''
      )}
    </>
  )
}

export default TaxDocumentsTab
